export interface Breadcrumb {
  Action: BreadcrumbAction,
  Link: string;
  Title: string;
}

export enum BreadcrumbAction {
  Link,
  Action
}
